// Tokens Keycloak usam base64url (sem padding, - e _ ao invés de + e /).
// atob() exige base64 padrão com padding — a conversão abaixo é obrigatória.
//
// Ordem de fallback dos claims:
// 1. `sub` — claim padrão JWT (presente nos tokens mocados de e2e/local).
// 2. `preferred_username` — Keycloak realm Serpro NÃO emite `sub`; o
//    CPF entra em `preferred_username` e é estável entre sessões.
// 3. `username` — fallback adicional, mesma semântica em outros realms.
export function extractJwtSub(token: string): string | null {
    try {
        const segment = token.split('.')[1]
            .replace(/-/g, '+')
            .replace(/_/g, '/');
        const padded = segment + '==='.slice((segment.length + 3) % 4);
        const payload = JSON.parse(atob(padded));
        const candidate =
            payload.sub || payload.preferred_username || payload.username;
        return typeof candidate === 'string' && candidate ? candidate : null;
    } catch {
        return null;
    }
}
